import React, { useEffect, useState } from "react";
import "./Clients.css";

import profileStaff from "../../assets/images/default-profile-icon-5.jpg";

import Barth from "../../assets/svg/bar.svg";
import Phone from "../../assets/svg/Phone.svg";
import email from "../../assets/svg/user.svg";
import male from "../../assets/svg/male 1.svg";
import car from "../../assets/svg/car.svg";
import Arrow from "../../assets/svg/Arrow.svg";
import galon from "../../assets/svg/galon.Icon.svg";
import batary from "../../assets/svg/batary.svg";
import CarWosh from "../../assets/svg/CarWosh.icon.svg";
import file from "../../assets/svg/file-text.svg";

import LastActive from "../../assets/svg/boint.svg";
import Pan from "../../assets/svg/PenEtat.svg";
import phoneIcon from "../../assets/svg/phoneCalling.svg";
import Email1 from "../../assets/svg/Email1.svg";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import OrdersOf from "../../components/OrdersOf";
import { GET_ALL_OPERATER_USERS } from "../../URLs/Apis";
import axios from "axios";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";
import InfoItem from "../../components/InfoItem";
import Overview_ClentInfo from "./Overview_ClentInfo";
import Vehicles_clientifo from "./Vehicles_clientifo";
import Orders_Clientinfo from "./Orders_Clientinfo";
import Locations_clientInfo from "./Locations_clientInfo";

const memberInfo = [Barth, Phone, email, car];

function ClientInfo() {
  const { user } = useSelector((state) => state.auth);
  const [operaterData, seOperaterData] = useState();

  //   useEffect(() => {
  //     getStaffData();
  //   }, []);
  //   const getStaffData = () => {
  //     const headers = {
  //       Authorization: "Bearer " + user?.token,
  //     };
  //     axios
  //       .get(
  //         GET_ALL_OPERATER_USERS + "/" + window.location.href.split("/").at(-1),
  //         {
  //           headers,
  //         }
  //       )
  //       .then((response) => {
  //         seOperaterData(response.data.data.operator);
  //       })
  //       .catch((error) => {
  //         console.log(error.message);
  //       });
  //   };

  const [value, setValue] = useState(0);
  return (
    <>
      <div className="profile">
        <div className="memberProfile">
          <p className="MPtitle"> {operaterData?.roles[0]?.name || "Agent"}</p>

          <div className="profileCard">
            <div className="img_clientInfo">
              <img
                className="personRel"
                src={
                  operaterData?.profile_photo_path
                    ? "https://estbn.com/MobileAppBackend/public" +
                      operaterData.profile_photo_path
                    : profileStaff
                }
                alt="Profile"
              />
            </div>
            <div className="profileName">
              <div className="nameOfMemberProfile">Menna Ashraf</div>
              <div className="edateTheName_client">
                <div className="edateTheName_client_img">
                  <img src={phoneIcon} alt="" />
                </div>
                <div className="edateTheName_client_img">
                  <img src={Email1} alt="" />
                </div>
                <div className="edateTheName_client_img">
                  <img src={Pan} alt="" />
                </div>
              </div>
            </div>
            <div className="Client_since">Client since 24 July, 2023</div>
            <div className="stuffprofileinfo">
              <div className="Client_info">Client Info</div>
              {memberInfo.map((e, i) => {
                return (
                  <div className="memberInfoItem">
                    <img className="clientInfoItem_img" src={e} alt="" />
                    <div className="memberInfotext">
                      {i === 0
                        ? dateFormat(operaterData?.birthdate, "dd/MM/yyyy")
                        : i === 1
                        ? operaterData?.phone_number || "no Data"
                        : i === 2
                        ? operaterData?.birthdate || "no Data"
                        : i === 3
                        ? operaterData?.gender || "no Data"
                        : i === 4
                        ? operaterData?.username || "no Data"
                        : operaterData?.email || "no Data"}
                    </div>
                  </div>
                );
              })}
              <div className="memberInfoItem">
                <img className="clientInfoItem_mg" src={LastActive} alt="" />
                <div className="memberInfotext">
                  {dateFormat(operaterData?.birthdate, "fullDate")}
                </div>
              </div>
            </div>
            <div className="stuffprofileinfo">
              <div className="agentInfo">Driver License</div>
              <div className="derverL_clientInfo">
                <img src={file} alt="" />
                driver license 2020.png
              </div>
            </div>
            <div className="stuffprofileinfo">
              <div className="agentInfo_spachile">
                <div>
                  Last Order <span className="fucesOnthis"># 210</span>
                </div>
                <img src={Arrow} className="stuffprofileinfo_arrow" alt="" />
              </div>
              <InfoItem
                label="Services:"
                value={
                  <div className="imge_Services_ClietInfo">
                    <img src={galon} alt="" />
                    <img src={CarWosh} alt="" />
                    <img src={batary} alt="" />
                  </div>
                }
              />
              <InfoItem label="Date:" value={"July 11 . 2024 " || "No Data"} />
              <InfoItem
                label="Time:"
                value={"09:00 am 12:00 pm" || "No Data"}
              />
            </div>
          </div>
        </div>
        <div className="memberDetals">
          <div className="memberMenuBar">
            <Box>
              <BottomNavigation
                showLabels
                value={value}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
                className="memberMenuBar_bottom Responsedesign"
              >
                <BottomNavigationAction
                  className="BottomNavigationAction"
                  label="Overview"
                />
                <BottomNavigationAction
                  className="BottomNavigationAction"
                  label="Vehicles"
                />
                <BottomNavigationAction
                  className="BottomNavigationAction"
                  label="Orders"
                />
                <BottomNavigationAction
                  className="BottomNavigationAction"
                  label="Locations"
                />
              </BottomNavigation>
            </Box>
          </div>
          {value === 0 ? (
            <div className="Cuntainer_ClientInfo">
              <Overview_ClentInfo />
            </div>
          ) : value === 1 ? (
            <div className="Cuntainer_ClientInfo">
              <Vehicles_clientifo />
            </div>
          ) : value === 2 ? (
            <div className="Cuntainer_ClientInfo_Items">
              <Orders_Clientinfo />
            </div>
          ) : (
            <div className="Cuntainer_ClientInfo">
              <Locations_clientInfo />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default ClientInfo;
